import gsap from 'gsap'

import Site from 'stores/Site'

import Page from 'classes/Page'

export default class Solutions extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()
    }

    initHero() {
        if (Site.isMobile) return

        const section = Site.page.querySelector('.s-solutions-hero')
        const wrapper = section.querySelector('.solutions')
        const solutions = wrapper.querySelectorAll('.solution')
        const solutionLinks = wrapper.querySelectorAll('.solution-anchor-link')

        solutions.forEach(el => {
            const text = el.querySelector('.solution-text')

            gsap.set(el, {
                height: wrapper.offsetHeight
            })

            gsap.set(text, {
                height: 0
            })

            el.addEventListener('mouseenter', () => {
                gsap.to(text, {
                    height: 'auto',
                    duration: .8,
                    ease: 'power3.out'
                })
            })

            el.addEventListener('mouseleave', () => {
                gsap.to(text, {
                    height: 0,
                    duration: .8,
                    ease: 'power3.out'
                })
            })
        })

        solutionLinks.forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault()

                const target = Site.page.querySelector(el.getAttribute('href'))

                if (target) {
                    e.preventDefault()
                    const top = target.getBoundingClientRect().top + window.scrollY - 126

                    window.scrollTo({
                        top,
                        behavior: 'smooth'
                    })
                }
            })
        })
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}